import { useQueryClient } from '@tanstack/react-query';

import { useAppDispatch } from '@verantos-dev/app-state-base';
import { resetCohortBuilderSlice } from '@verantos-dev/app-state-cohort-builder';
import { useCohortDefinitionStore } from '@verantos-dev/app-state-cohort-definition';
import { resetResearchAssistantState } from '@verantos-dev/app-state-research-assistant';
import { avKeys } from '@verantos-dev/feature-analytical-variables';

export const useResetCohortBuilderState = () => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  const resetCohortBuilderState = () => {
    dispatch(resetCohortBuilderSlice());
    dispatch(resetResearchAssistantState());
    useCohortDefinitionStore.getState().reset();
    // Remove stale TQ cache so that on next visit the store is hydrated from the
    // server rather than from a snapshot that pre-dates the unsaved local changes.
    queryClient.removeQueries({ queryKey: avKeys.lists() });
  };

  return { resetCohortBuilderState };
};
